import { InteractiveModuleFutureProjectionModel, InteractiveModuleTemplateModel } from './';

export class InteractiveModuleFutureProjectionGroupedModel {
    InteractiveModuleTemplateId: number;
    Template: InteractiveModuleTemplateModel;
    Instances: InteractiveModuleFutureProjectionModel[];
}